// extracted by mini-css-extract-plugin
export default {"TableActions":"Index_TableActions__ES+Xk"};